export default "__VITE_ASSET__BdSosy19__"